(() => {
  const initTimeline = (section) => {
    if (!section || section.dataset.dartsrxTimelineReady === 'true') return;

    const slides = Array.from(section.querySelectorAll('[data-dartsrx-timeline-slide]'));
    const mediaPanes = Array.from(section.querySelectorAll('[data-dartsrx-timeline-media]'));
    const dots = Array.from(section.querySelectorAll('[data-dartsrx-timeline-dot]'));
    const prev = section.querySelector('[data-dartsrx-timeline-prev]');
    const next = section.querySelector('[data-dartsrx-timeline-next]');
    const count = section.querySelector('[data-dartsrx-timeline-count]');

    if (!slides.length) return;

    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

    const setActive = (index) => {
      activeIndex = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.hidden = !isActive;
      });

      mediaPanes.forEach((pane, paneIndex) => {
        const isActive = paneIndex === activeIndex;
        pane.classList.toggle('is-active', isActive);
        pane.hidden = !isActive;
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        dot.tabIndex = isActive ? 0 : -1;
      });

      if (count) {
        count.textContent = `${activeIndex + 1} / ${slides.length}`;
      }
    };

    prev?.addEventListener('click', () => setActive(activeIndex - 1));
    next?.addEventListener('click', () => setActive(activeIndex + 1));

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => setActive(dotIndex));
      dot.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          setActive(activeIndex + 1);
          dots[activeIndex]?.focus();
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          setActive(activeIndex - 1);
          dots[activeIndex]?.focus();
        }
      });
    });

    section.dataset.dartsrxTimelineReady = 'true';
    setActive(activeIndex);
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-dartsrx-timeline]').forEach(initTimeline);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
